webpackJsonp([21],{

/***/ 1120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalculatorView_vue__ = __webpack_require__(1276);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04dc3278_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalculatorView_vue__ = __webpack_require__(1439);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalculatorView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04dc3278_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalculatorView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  getCalculator: function getCalculator(eventId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/calculator"));
  },
  createCalculator: function createCalculator(eventId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/events/".concat(eventId, "/calculator"), data, {
      silent: true
    });
  },
  updateCalculator: function updateCalculator(calculatorId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/calculators/".concat(calculatorId), data, {
      silent: true
    });
  },
  getDraftPrizeSummary: function getDraftPrizeSummary(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/prize-summary"));
  }
});

/***/ }),

/***/ 1276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AppMultiselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DesktopActionBar__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Calculators_CalculatorSidebar__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_EventBus__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__composables_calculators_useCalculatorView__ = __webpack_require__(1437);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'CalculatorView',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_3__components_AppButton__["a" /* default */],
    AppMultiselect: __WEBPACK_IMPORTED_MODULE_4__components_AppMultiselect__["a" /* default */],
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_5__components_DesktopActionBar__["a" /* default */],
    CalculatorSidebar: __WEBPACK_IMPORTED_MODULE_6__components_Calculators_CalculatorSidebar__["a" /* default */]
  },
  setup: function setup() {
    var vm = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])();
    var router = vm.proxy.$router;
    var eventId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return vm.proxy.$route.params.eventId;
    });

    var _useCalculatorView = Object(__WEBPACK_IMPORTED_MODULE_8__composables_calculators_useCalculatorView__["a" /* default */])(eventId.value),
        draftName = _useCalculatorView.draftName,
        eventsList = _useCalculatorView.eventsList,
        eventName = _useCalculatorView.eventName,
        totalNominations = _useCalculatorView.totalNominations,
        totalRounds = _useCalculatorView.totalRounds,
        declaredPrize = _useCalculatorView.declaredPrize,
        backAmount = _useCalculatorView.backAmount,
        totalPrize = _useCalculatorView.totalPrize,
        rounds = _useCalculatorView.rounds,
        loading = _useCalculatorView.loading,
        submitting = _useCalculatorView.submitting,
        hasCalculated = _useCalculatorView.hasCalculated,
        unsaved = _useCalculatorView.unsaved,
        setEventId = _useCalculatorView.setEventId,
        fetchCalculator = _useCalculatorView.fetchCalculator,
        calculateRounds = _useCalculatorView.calculateRounds,
        onRoundMoneyChange = _useCalculatorView.onRoundMoneyChange,
        onRoundPercentChange = _useCalculatorView.onRoundPercentChange,
        onRoundPlacesChange = _useCalculatorView.onRoundPlacesChange,
        toggleColumnEdit = _useCalculatorView.toggleColumnEdit,
        saveCalculator = _useCalculatorView.saveCalculator;

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      if (eventId.value) fetchCalculator();
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(eventId, function (newId) {
      if (newId) {
        setEventId(newId);
        fetchCalculator();
      }
    }); // Places 3-50 (CAM-1235) — searchable via app-multiselect so a secretary can type
    // a place number instead of scrolling a 48-option list.

    var placesOptions = Array.from({
      length: 48
    }, function (_, i) {
      return i + 3;
    }).map(function (value) {
      return {
        value: value,
        label: String(value)
      };
    });

    function onPlacesChange(round, option) {
      if (option == null) return;
      onRoundPlacesChange(round, option.value);
    }

    function onCalculate() {
      calculateRounds();
    } // Monolith redirects to /draws/view after a successful save — mirror that.


    function onSave() {
      return _onSave.apply(this, arguments);
    }

    function _onSave() {
      _onSave = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return saveCalculator();

              case 2:
                result = _context.sent;

                if (result.success) {
                  _context.next = 6;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7__store_EventBus__["a" /* default */].$emit('http-error', result.message);
                return _context.abrupt("return");

              case 6:
                router.push('/draws/dashboard').then(function () {
                  if (result.message) __WEBPACK_IMPORTED_MODULE_7__store_EventBus__["a" /* default */].$emit('show-success', result.message);
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _onSave.apply(this, arguments);
    }

    return {
      MOCK_DRAFT_NAME: draftName,
      MOCK_EVENTS_LIST: eventsList,
      MOCK_EVENT_ID: Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
        return Number(eventId.value);
      }),
      MOCK_EVENT_NAME: eventName,
      MOCK_TOTAL_NOMINATIONS: totalNominations,
      MOCK_TOTAL_ROUNDS: totalRounds,
      MOCK_DECLARED: declaredPrize,
      MOCK_BACK_AMOUNT: backAmount,
      MOCK_UNSAVED: unsaved,
      MOCK_CALCULATED: hasCalculated,
      MOCK_TOTAL_PRIZE: totalPrize,
      MOCK_ROUNDS: rounds,
      loading: loading,
      submitting: submitting,
      placesOptions: placesOptions,
      onPlacesChange: onPlacesChange,
      onRoundMoneyChange: onRoundMoneyChange,
      onRoundPercentChange: onRoundPercentChange,
      toggleColumnEdit: toggleColumnEdit,
      onCalculate: onCalculate,
      onSave: onSave
    };
  }
}));

/***/ }),

/***/ 1277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'CalculatorSidebar',
  props: {
    draftName: {
      type: String,
      default: ''
    },
    events: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    currentEventId: {
      type: Number,
      default: null
    }
  }
}));

/***/ }),

/***/ 1433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalculatorSidebar_vue__ = __webpack_require__(1277);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c5a32ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalculatorSidebar_vue__ = __webpack_require__(1436);
function injectStyle (ssrContext) {
  __webpack_require__(1434)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9c5a32ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalculatorSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c5a32ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalculatorSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1434:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1435);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("59a56d18", content, true, {});

/***/ }),

/***/ 1435:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".col-navbar[data-v-9c5a32ea]{flex:0 1 220px;max-width:220px}.col-navbar .nav-link[data-v-9c5a32ea]{font-size:.9375rem;white-space:normal!important}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/Calculators/CalculatorSidebar.vue"],"names":[],"mappings":"AACA,6BAA6B,eAAe,eAAe,CAC1D,AACD,uCAAuC,mBAAmB,4BAA8B,CACvF","file":"CalculatorSidebar.vue","sourcesContent":["\n.col-navbar[data-v-9c5a32ea]{flex:0 1 220px;max-width:220px\n}\n.col-navbar .nav-link[data-v-9c5a32ea]{font-size:.9375rem;white-space:initial !important\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"col-12 col-navbar d-lg-flex align-items-start flex-column bg-dark px-0"},[_c('div',{staticClass:"navbar navbar-expand navbar-dark flex-grow-1 align-items-start flex-column w-100"},[_c('ul',{staticClass:"nav navbar-nav flex-column flex-grow-1 w-100"},[_c('li',{staticClass:"nav-item nav-item-active"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/draws/dashboard"}},[_vm._v(_vm._s(_vm.draftName))]),_vm._v(" "),_c('ul',{staticClass:"pl-0"},_vm._l((_vm.events),function(event){return _c('li',{key:event.id,staticClass:"nav-item"},[_c('router-link',{class:['nav-link', { active: event.event_id === _vm.currentEventId }],attrs:{"to":'/calculators/' + event.event_id}},[_vm._v("\n              "+_vm._s(event.name)+"\n            ")])],1)}),0)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useCalculatorView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_calculators__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_calculatorRules__ = __webpack_require__(1438);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





function calcPlacing(money, isFinal, totalCompetitors) {
  if (isFinal) {
    var _rule = __WEBPACK_IMPORTED_MODULE_2__constants_calculatorRules__["a" /* FINAL_ROUND_PLACING */].find(function (r) {
      return totalCompetitors >= r.min && totalCompetitors <= r.max;
    });

    return _rule ? _rule.value : 6;
  }

  var rule = __WEBPACK_IMPORTED_MODULE_2__constants_calculatorRules__["d" /* ROUND_PLACING */].find(function (r) {
    return money >= r.min && money < r.max;
  });
  return rule ? rule.value : 4;
}

function buildPlacesData(money, places) {
  var percentArray = __WEBPACK_IMPORTED_MODULE_2__constants_calculatorRules__["b" /* PLACES_MONEY_DIVISION */][places] || __WEBPACK_IMPORTED_MODULE_2__constants_calculatorRules__["b" /* PLACES_MONEY_DIVISION */][4];
  return percentArray.map(function (pct, idx) {
    return {
      place: idx + 1,
      percent: pct,
      amount: parseFloat((money * pct / 100).toFixed(2))
    };
  });
}

function buildRound(order, isFinal, totalMoney, percentValue, totalCompetitors) {
  var money = parseFloat((totalMoney * percentValue / 100).toFixed(2));
  var places = calcPlacing(money, isFinal, totalCompetitors);
  return {
    id: null,
    order: order,
    is_final: isFinal,
    money: money,
    percent: percentValue,
    places: places,
    placesData: buildPlacesData(money, places),
    editingColumn: null
  };
}

function mapRoundsFromApi(apiRounds) {
  return apiRounds.map(function (r) {
    return {
      id: r.id,
      order: r.order,
      is_final: r.is_final,
      money: r.sum,
      percent: r.percentages,
      places: r.places,
      placesData: (r.calc_places || []).map(function (p) {
        return {
          place: p.place,
          percent: p.percentage,
          amount: p.sum
        };
      }),
      editingColumn: null
    };
  });
}

function mapRoundsToApi(uiRounds) {
  return uiRounds.map(function (r) {
    return {
      round_order: r.order,
      round_money: r.money,
      round_percent: r.percent,
      round_placing: r.places,
      is_final: r.is_final,
      table_data: (r.placesData || []).map(function (p) {
        return {
          place: p.place,
          percent: p.percent,
          money: p.amount
        };
      })
    };
  });
}

function useCalculatorView(initialEventId) {
  var eventId = initialEventId;
  var calculatorId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var draftName = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('');
  var eventsList = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var eventName = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('');
  var totalNominations = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(0);
  var totalRounds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(0);
  var declaredPrize = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(0);
  var backAmount = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var rounds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var submitting = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var hasCalculated = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var unsaved = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var totalPrize = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    var dec = declaredPrize.value != null ? Number(declaredPrize.value) : 0;
    var back = backAmount.value != null ? Number(backAmount.value) : 0;
    var competitors = totalNominations.value || 0;
    return (dec + back * competitors).toFixed(2);
  });

  function fetchCalculator() {
    return _fetchCalculator.apply(this, arguments);
  }

  function _fetchCalculator() {
    _fetchCalculator = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_calculators__["a" /* default */].getCalculator(eventId);

            case 4:
              res = _context.sent;
              data = res.data.data;

              if (!(data == null)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              calculatorId.value = data.id != null ? data.id : null;
              draftName.value = data.draftName || '';
              eventsList.value = Array.isArray(data.eventsList) ? data.eventsList : [];
              eventName.value = data.event != null ? data.event.name : '';
              totalNominations.value = data.totalCompetitors != null ? data.totalCompetitors : 0;
              totalRounds.value = data.event != null ? data.event.rounds : 0;
              declaredPrize.value = data.event != null ? data.event.declared_prize : 0;
              backAmount.value = data.event != null ? data.event.back_amount : null;

              if (data.rounds != null && data.rounds.length > 0) {
                rounds.value = mapRoundsFromApi(data.rounds);
                hasCalculated.value = true;
              } else {
                hasCalculated.value = false;
              }

              _context.next = 21;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](1);

            case 21:
              _context.prev = 21;
              loading.value = false;
              return _context.finish(21);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 19, 21, 24]]);
    }));
    return _fetchCalculator.apply(this, arguments);
  }

  function calculateRounds() {
    var total = Number(totalPrize.value) || 0;
    if (total <= 0) return;
    var numRounds = totalRounds.value || 1;
    var percentages = __WEBPACK_IMPORTED_MODULE_2__constants_calculatorRules__["c" /* ROUND_MONEY_DIVISION */][numRounds] || __WEBPACK_IMPORTED_MODULE_2__constants_calculatorRules__["c" /* ROUND_MONEY_DIVISION */][1];
    var competitors = totalNominations.value || 0;
    var newRounds = [];

    for (var i = 0; i < numRounds; i++) {
      var isFinal = i === numRounds - 1;
      newRounds.push(buildRound(i + 1, isFinal, total, percentages[i], competitors));
    }

    rounds.value = newRounds;
    hasCalculated.value = true;
    unsaved.value = true;
  }

  function onRoundMoneyChange(round) {
    var money = parseFloat(round.money) || 0;
    round.money = money;
    var total = rounds.value.reduce(function (s, r) {
      return s + (parseFloat(r.money) || 0);
    }, 0);
    var back = backAmount.value != null ? Number(backAmount.value) : 0;
    var competitors = totalNominations.value || 0;
    declaredPrize.value = parseFloat((total - back * competitors).toFixed(2));
    rounds.value.forEach(function (r) {
      var t = Number(totalPrize.value) || 0;
      r.percent = t > 0 ? parseFloat((parseFloat(r.money) / t * 100).toFixed(2)) : 0;
      r.places = calcPlacing(r.money, r.is_final, competitors);
      r.placesData = buildPlacesData(r.money, r.places);
    });
    unsaved.value = true;
  }

  function onRoundPercentChange(round) {
    var pct = parseFloat(round.percent) || 0;
    round.percent = pct;
    var total = Number(totalPrize.value) || 0;
    round.money = parseFloat((total * pct / 100).toFixed(2));
    var competitors = totalNominations.value || 0;
    var sumMoney = rounds.value.reduce(function (s, r) {
      return s + (parseFloat(r.money) || 0);
    }, 0);
    var back = backAmount.value != null ? Number(backAmount.value) : 0;
    declaredPrize.value = parseFloat((sumMoney - back * competitors).toFixed(2));
    rounds.value.forEach(function (r) {
      r.places = calcPlacing(r.money, r.is_final, competitors);
      r.placesData = buildPlacesData(r.money, r.places);
    });
    unsaved.value = true;
  }

  function onRoundPlacesChange(round, newPlaces) {
    round.places = newPlaces;
    round.placesData = buildPlacesData(round.money, round.places);
    unsaved.value = true;
  } // After a per-place column edit, the round's money is whatever the edited
  // places now sum to, which shifts the overall total — every round's
  // "% of Total" needs to follow, not just the one that was edited.


  function recalcRoundPercentsFromMoney() {
    var total = rounds.value.reduce(function (s, r) {
      return s + (parseFloat(r.money) || 0);
    }, 0);
    var back = backAmount.value != null ? Number(backAmount.value) : 0;
    var competitors = totalNominations.value || 0;
    declaredPrize.value = parseFloat((total - back * competitors).toFixed(2));
    var newTotal = Number(totalPrize.value) || 0;
    rounds.value.forEach(function (r) {
      r.percent = newTotal > 0 ? parseFloat((parseFloat(r.money) / newTotal * 100).toFixed(2)) : 0;
    });
  }

  function applyPercentColumnEdit(round) {
    round.placesData.forEach(function (p) {
      p.percent = parseFloat(p.percent) || 0;
      p.amount = parseFloat((round.money * p.percent / 100).toFixed(2));
    });
    round.money = parseFloat(round.placesData.reduce(function (s, p) {
      return s + p.amount;
    }, 0).toFixed(2));
    recalcRoundPercentsFromMoney();
    unsaved.value = true;
  }

  function applyMoneyColumnEdit(round) {
    round.placesData.forEach(function (p) {
      p.amount = parseFloat(p.amount) || 0;
    });
    round.money = parseFloat(round.placesData.reduce(function (s, p) {
      return s + p.amount;
    }, 0).toFixed(2));
    round.placesData.forEach(function (p) {
      p.percent = round.money > 0 ? parseFloat((p.amount / round.money * 100).toFixed(2)) : 0;
    });
    recalcRoundPercentsFromMoney();
    unsaved.value = true;
  }

  function toggleColumnEdit(round, column) {
    if (round.editingColumn === column) {
      if (column === 'percent') applyPercentColumnEdit(round);
      if (column === 'money') applyMoneyColumnEdit(round);
      round.editingColumn = null;
      return;
    }

    if (round.editingColumn != null) return;
    round.editingColumn = column;
  }

  function saveCalculator() {
    return _saveCalculator.apply(this, arguments);
  }

  function _saveCalculator() {
    _saveCalculator = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      var payload, created, res, _error$response, _error$response$data, message;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              submitting.value = true;
              _context2.prev = 1;
              payload = {
                declared_money: declaredPrize.value != null ? Number(declaredPrize.value) : 0,
                back_money: backAmount.value != null ? Number(backAmount.value) : 0,
                total_money: totalPrize.value != null ? Number(totalPrize.value) : 0,
                rounds: mapRoundsToApi(rounds.value)
              }; // POST only creates the calculator record — rounds data is saved by PATCH.

              if (calculatorId.value) {
                _context2.next = 8;
                break;
              }

              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_calculators__["a" /* default */].createCalculator(eventId, {});

            case 6:
              created = _context2.sent;
              calculatorId.value = created.data.data != null ? created.data.data.id : null;

            case 8:
              _context2.next = 10;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_calculators__["a" /* default */].updateCalculator(calculatorId.value, payload);

            case 10:
              res = _context2.sent;
              unsaved.value = false;
              return _context2.abrupt("return", {
                success: true,
                message: res.data.message
              });

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](1);
              message = ((_error$response = _context2.t0.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || 'A server error occurred. Please try again later.';
              return _context2.abrupt("return", {
                success: false,
                message: message
              });

            case 19:
              _context2.prev = 19;
              submitting.value = false;
              return _context2.finish(19);

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 15, 19, 22]]);
    }));
    return _saveCalculator.apply(this, arguments);
  }

  return {
    calculatorId: calculatorId,
    draftName: draftName,
    eventsList: eventsList,
    eventName: eventName,
    totalNominations: totalNominations,
    totalRounds: totalRounds,
    declaredPrize: declaredPrize,
    backAmount: backAmount,
    totalPrize: totalPrize,
    rounds: rounds,
    loading: loading,
    submitting: submitting,
    hasCalculated: hasCalculated,
    unsaved: unsaved,
    setEventId: function setEventId(newId) {
      eventId = newId;
    },
    fetchCalculator: fetchCalculator,
    calculateRounds: calculateRounds,
    onRoundMoneyChange: onRoundMoneyChange,
    onRoundPercentChange: onRoundPercentChange,
    onRoundPlacesChange: onRoundPlacesChange,
    toggleColumnEdit: toggleColumnEdit,
    saveCalculator: saveCalculator
  };
}

/***/ }),

/***/ 1438:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ROUND_MONEY_DIVISION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ROUND_PLACING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FINAL_ROUND_PLACING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PLACES_MONEY_DIVISION; });
var ROUND_MONEY_DIVISION = {
  1: [100],
  2: [20, 80],
  3: [15, 15, 70],
  4: [10, 10, 10, 70],
  5: [10, 10, 10, 10, 60]
};
var ROUND_PLACING = [{
  min: 0,
  max: 500,
  value: 4
}, {
  min: 500,
  max: 1000,
  value: 6
}, {
  min: 1000,
  max: Infinity,
  value: 8
}];
var FINAL_ROUND_PLACING = [{
  min: 1,
  max: 160,
  value: 6
}, {
  min: 161,
  max: 399,
  value: 8
}, {
  min: 400,
  max: 499,
  value: 10
}, {
  min: 500,
  max: Infinity,
  value: 12
}]; // Percentage split of round money per place, keyed by "Number of places" (CAM-1235).
// 3-12 are ACA-confirmed as-is. 13-50 come from ACA's draft spreadsheet: 13-18 already summed
// to 100 and are used verbatim; 19-50 did not (off by up to +16), so those rows were rescaled
// proportionally and rounded to whole percents via the largest-remainder method to force an
// exact 100 while preserving ACA's relative place-to-place shape and rank order.

var PLACES_MONEY_DIVISION = {
  3: [50, 30, 20],
  4: [40, 30, 20, 10],
  5: [32, 24, 18, 14, 12],
  6: [25, 21, 18, 15, 12, 9],
  7: [22, 19, 16, 14, 12, 9, 8],
  8: [20, 18, 16, 13, 11, 9, 7, 6],
  9: [19, 16, 14, 12, 11, 9, 7, 6, 6],
  10: [18, 15, 12, 11, 10, 9, 8, 7, 5, 5],
  11: [17, 14, 12, 11, 10, 9, 8, 7, 5, 4, 3],
  12: [18, 16, 14, 12, 10, 9, 6, 5, 4, 3, 2, 1],
  13: [15, 13, 12, 11, 10, 9, 8, 7, 5, 4, 3, 2, 1],
  14: [14, 13, 12, 11, 10, 9, 8, 7, 5, 4, 3, 2, 1, 1],
  15: [14, 12, 11, 10, 9, 8, 7, 6, 5, 4, 4, 3, 3, 2, 2],
  16: [13, 12, 11, 10, 9, 8, 7, 6, 5, 5, 4, 3, 3, 2, 1, 1],
  17: [13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 4, 3, 3, 2, 1, 1, 1],
  18: [12, 11, 10, 9, 8, 8, 7, 6, 5, 5, 4, 4, 3, 2, 2, 2, 1, 1],
  19: [11, 10, 9, 8, 8, 7, 7, 6, 6, 5, 5, 4, 4, 3, 2, 2, 1, 1, 1],
  20: [11, 10, 9, 8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 3, 3, 2, 2, 2, 2, 1],
  21: [10, 9, 8, 8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 3, 3, 3, 2, 2, 2, 2, 1],
  22: [10, 9, 8, 8, 7, 6, 6, 5, 5, 4, 4, 4, 4, 3, 3, 3, 3, 2, 2, 2, 1, 1],
  23: [10, 9, 8, 7, 7, 6, 6, 5, 5, 4, 4, 4, 4, 3, 3, 3, 3, 2, 2, 2, 1, 1, 1],
  24: [9, 8, 8, 7, 7, 6, 6, 5, 5, 4, 4, 4, 4, 3, 3, 3, 3, 2, 2, 2, 2, 1, 1, 1],
  25: [9, 8, 8, 7, 7, 6, 6, 5, 5, 4, 4, 4, 3, 3, 3, 3, 3, 2, 2, 2, 2, 1, 1, 1, 1],
  26: [9, 8, 7, 7, 7, 6, 6, 5, 5, 4, 4, 4, 3, 3, 3, 3, 3, 2, 2, 2, 2, 1, 1, 1, 1, 1],
  27: [8, 8, 7, 7, 6, 6, 6, 5, 5, 4, 4, 4, 4, 3, 3, 3, 3, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1],
  28: [8, 7, 7, 6, 6, 6, 5, 5, 5, 4, 4, 4, 4, 3, 3, 3, 3, 3, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1],
  29: [8, 7, 7, 6, 6, 5, 5, 5, 4, 4, 4, 4, 4, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1],
  30: [8, 7, 7, 6, 6, 5, 5, 5, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1],
  31: [7, 7, 6, 6, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1],
  32: [7, 6, 6, 6, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1],
  33: [7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  34: [7, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  35: [7, 6, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  36: [6, 6, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  37: [6, 6, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  38: [6, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  39: [6, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  40: [6, 6, 5, 5, 5, 4, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  41: [6, 5, 5, 5, 4, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  42: [6, 5, 5, 5, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  43: [5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  44: [5, 5, 5, 4, 4, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  45: [5, 5, 5, 4, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  46: [5, 5, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  47: [5, 5, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  48: [5, 5, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  49: [5, 5, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  50: [5, 5, 5, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
};

/***/ }),

/***/ 1439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('calculator-sidebar',{attrs:{"slot":"sidebar","draft-name":_vm.MOCK_DRAFT_NAME,"events":_vm.MOCK_EVENTS_LIST,"current-event-id":_vm.MOCK_EVENT_ID},slot:"sidebar"}),_vm._v(" "),_c('div',{staticClass:"ml-0 row mx-0",attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('div',{staticClass:"col px-0 pr-lg-3"},[_c('div',{staticClass:"bg-white rounded mb-4 p-3 pb-5"},[_c('page-heading',[_vm._v("Prize Money Calculator")]),_vm._v(" "),_c('h2',{staticClass:"h3 mb-3"},[_vm._v(_vm._s(_vm.MOCK_EVENT_NAME))]),_vm._v(" "),_c('div',{staticClass:"alert alert-info alert-simple"},[_vm._v("\n            PRIZEMONEY CAN BE CHANGED LATER. PLEASE PRESS \"CALCULATE ROUND MONEY\" AND \"FINALISE EVENT\" TO VIEW RESULTS.\n          ")]),_vm._v(" "),(_vm.MOCK_UNSAVED)?_c('div',{staticClass:"alert alert-warning"},[_c('a',{staticClass:"close",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.MOCK_UNSAVED = false}}},[_vm._v("×")]),_vm._v("\n            There are unsaved changes.\n          ")]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"calc-info mb-5 px-sm-3 py-sm-4"},[_c('form',{staticClass:"calc-info__numbers"},[_c('div',{staticClass:"calc-row"},[_c('div',{staticClass:"calc-row__heading"},[_vm._v("Total nominations:")]),_vm._v(" "),_c('div',{staticClass:"calc-row__property"},[_vm._v(_vm._s(_vm.MOCK_TOTAL_NOMINATIONS))])]),_vm._v(" "),_c('div',{staticClass:"calc-row"},[_c('div',{staticClass:"calc-row__heading"},[_vm._v("Total rounds: "),_c('span',[_vm._v("(including Final)")])]),_vm._v(" "),_c('div',{staticClass:"calc-row__property"},[_vm._v(_vm._s(_vm.MOCK_TOTAL_ROUNDS))])]),_vm._v(" "),_c('div',{staticClass:"calc-row"},[_c('div',{staticClass:"calc-row__heading"},[_vm._v("Declared prize money:")]),_vm._v(" "),_c('div',{staticClass:"calc-row__property"},[_c('div',{staticClass:"calc-row__input-wrap --dollar-icon"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MOCK_DECLARED),expression:"MOCK_DECLARED"}],staticClass:"calc-row__input",attrs:{"type":"number"},domProps:{"value":(_vm.MOCK_DECLARED)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.MOCK_DECLARED=$event.target.value},function($event){_vm.MOCK_UNSAVED = true}]}})])])]),_vm._v(" "),_c('div',{staticClass:"calc-row"},[_c('div',{staticClass:"calc-row__heading"},[_vm._v("Add back amount: "),_c('span',[_vm._v("(leave blank if none)")])]),_vm._v(" "),_c('div',{staticClass:"calc-row__property"},[_c('div',{staticClass:"calc-row__input-wrap --dollar-icon"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MOCK_BACK_AMOUNT),expression:"MOCK_BACK_AMOUNT"}],staticClass:"calc-row__input",attrs:{"type":"number"},domProps:{"value":(_vm.MOCK_BACK_AMOUNT)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.MOCK_BACK_AMOUNT=$event.target.value},function($event){_vm.MOCK_UNSAVED = true}]}})])])]),_vm._v(" "),_c('div',{staticClass:"calc-row"},[_c('div',{staticClass:"calc-row__heading"},[_vm._v("Total prize money:")]),_vm._v(" "),_c('div',{staticClass:"calc-row__property"},[_c('i',{staticClass:"icon-dollar-sign"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.MOCK_TOTAL_PRIZE))])])]),_vm._v(" "),_c('div',{staticClass:"calc-info__submit"},[_c('input',{staticClass:"btn btn-primary btn-default",attrs:{"type":"button","value":"Calculate Round Money"},on:{"click":_vm.onCalculate}})])])]),_vm._v(" "),(_vm.MOCK_CALCULATED)?_c('section',{staticClass:"calc-rounds"},[_c('h3',{staticClass:"h5 mb-3"},[_vm._v("Rounds Prize Money")]),_vm._v(" "),_c('div',{staticClass:"calc-rounds__wrap"},_vm._l((_vm.MOCK_ROUNDS),function(round,idx){return _c('div',{key:round.id,staticClass:"calc-round"},[_c('div',{staticClass:"calc-round__header"},[_vm._v("\n                  "+_vm._s(idx === _vm.MOCK_ROUNDS.length - 1 ? 'Final Round' : 'Round ' + (idx + 1))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"calc-round__body"},[_c('div',{staticClass:"calc-round__main-info"},[_c('div',{staticClass:"calc-row"},[_c('div',{staticClass:"calc-row__heading"},[_vm._v("Round money:")]),_vm._v(" "),_c('div',{staticClass:"calc-row__property"},[_c('div',{staticClass:"calc-row__input-wrap --dollar-icon"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(round.money),expression:"round.money"}],staticClass:"calc-row__input",attrs:{"type":"number"},domProps:{"value":(round.money)},on:{"change":function($event){return _vm.onRoundMoneyChange(round)},"input":function($event){if($event.target.composing){ return; }_vm.$set(round, "money", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"calc-row"},[_c('div',{staticClass:"calc-row__heading"},[_vm._v("% of Total:")]),_vm._v(" "),_c('div',{staticClass:"calc-row__property"},[_c('div',{staticClass:"calc-row__input-wrap --percent-icon"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(round.percent),expression:"round.percent"}],staticClass:"calc-row__input",attrs:{"type":"number"},domProps:{"value":(round.percent)},on:{"change":function($event){return _vm.onRoundPercentChange(round)},"input":function($event){if($event.target.composing){ return; }_vm.$set(round, "percent", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"calc-row"},[_c('div',{staticClass:"calc-row__heading"},[_vm._v("Number of places:")]),_vm._v(" "),_c('div',{staticClass:"calc-row__property"},[_c('div',{staticClass:"calc-row__input-wrap"},[_c('app-multiselect',{attrs:{"value":_vm.placesOptions.find(function (o) { return o.value === round.places; }),"options":_vm.placesOptions,"label":"label","track-by":"value","allow-empty":false},on:{"input":function($event){return _vm.onPlacesChange(round, $event)}}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"calc-round__table round-table round-table_tac"},[_c('div',{staticClass:"round-table__header"},[_c('div',{staticClass:"round-table__row"},[_c('div',{staticClass:"round-table__cell col-4"},[_vm._v("Place")]),_vm._v(" "),_c('div',{staticClass:"round-table__cell col-4"},[_c('i',{staticClass:"icon-percent"}),_vm._v(" "),_c('i',{staticClass:"round-table__edit",class:{ active: round.editingColumn === 'percent', disabled: round.editingColumn === 'money' },on:{"click":function($event){return _vm.toggleColumnEdit(round, 'percent')}}})]),_vm._v(" "),_c('div',{staticClass:"round-table__cell col-4"},[_c('i',{staticClass:"icon-dollar-sign"}),_vm._v(" "),_c('i',{staticClass:"round-table__edit",class:{ active: round.editingColumn === 'money', disabled: round.editingColumn === 'percent' },on:{"click":function($event){return _vm.toggleColumnEdit(round, 'money')}}})])])]),_vm._v(" "),_c('div',{staticClass:"round-table__body"},_vm._l((round.placesData),function(p){return _c('div',{key:p.place,staticClass:"round-table__row"},[_c('div',{staticClass:"round-table__cell col-4"},[_vm._v(_vm._s(p.place))]),_vm._v(" "),_c('div',{staticClass:"round-table__cell col-4"},[(round.editingColumn === 'percent')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(p.percent),expression:"p.percent"}],staticClass:"round-table__edit-input",attrs:{"type":"number"},domProps:{"value":(p.percent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(p, "percent", $event.target.value)}}}):[_vm._v(_vm._s(p.percent))]],2),_vm._v(" "),_c('div',{staticClass:"round-table__cell col-4"},[(round.editingColumn === 'money')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(p.amount),expression:"p.amount"}],staticClass:"round-table__edit-input",attrs:{"type":"number"},domProps:{"value":(p.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(p, "amount", $event.target.value)}}}):[_vm._v(_vm._s(p.amount))]],2)])}),0),_vm._v(" "),_c('div',{staticClass:"round-table__total"},[_c('div',{staticClass:"round-table__row"},[_c('div',{staticClass:"round-table__cell col-4"},[_vm._v("TOTAL")]),_vm._v(" "),_c('div',{staticClass:"round-table__cell col-4"},[_vm._v("\n                          "+_vm._s(round.placesData.reduce(function(s, p) { return s + Number(p.percent) }, 0).toFixed(1))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"round-table__cell col-4"},[_vm._v("\n                          "+_vm._s(round.placesData.reduce(function(s, p) { return s + Number(p.amount) }, 0).toFixed(2))+"\n                        ")])])])])])])}),0),_vm._v(" "),_c('div',{staticClass:"col-12 d-lg-none mt-4 px-0"},[_c('app-button',{attrs:{"disabled":!_vm.MOCK_CALCULATED || _vm.submitting},on:{"click":_vm.onSave}},[_vm._v("\n                Finalise Event\n              ")])],1)]):_vm._e()],1)]),_vm._v(" "),_c('desktop-action-bar',[_c('app-button',{attrs:{"disabled":!_vm.MOCK_CALCULATED || _vm.submitting},on:{"click":_vm.onSave}},[_vm._v("\n          Finalise Event\n        ")]),_vm._v(" "),_c('div',{staticClass:"calc-info__small-text mt-2"},[_vm._v("\n          Updates all the actual prize money to the figures below for this event.\n          This will overwrite current prize money values but not if paid out.\n        ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/21.3d8e4aea37bf30c63430.js